// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Container = require("../common/Components/Container.bs.js");
let PageTitle = require("../common/Components/PageTitle.bs.js");
let PageViews = require("../../reason/PageViews.bs.js");
let AuthSession = require("../../utils/AuthSession.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let ReactErrorBoundary = require("react-error-boundary");
let FragmentErrorBoundary = require("../common/Components/FragmentErrorBoundary.bs.js");
let DashboardCardComponents__Tw = require("./DashboardCardComponents__Tw.bs.js");
let ChapterDashboard__PropertyStats = require("./ChapterDashboard__PropertyStats.bs.js");
let ChapterDashboard__BuyerNeedStats = require("./ChapterDashboard__BuyerNeedStats.bs.js");
let ChapterDashboard__ChapterMembers = require("./ChapterDashboard__ChapterMembers.bs.js");
let ChapterDashboard__UpcomingShowings = require("./ChapterDashboard__UpcomingShowings.bs.js");
let ChapterDashboard__BroadcastMessages = require("./ChapterDashboard__BroadcastMessages.bs.js");
let ChapterDashboardRelayPageQuery_graphql = require("../../__generated__/ChapterDashboardRelayPageQuery_graphql.bs.js");

let convertVariables = ChapterDashboardRelayPageQuery_graphql.Internal.convertVariables;

let convertResponse = ChapterDashboardRelayPageQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = ChapterDashboardRelayPageQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, ChapterDashboardRelayPageQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, ChapterDashboardRelayPageQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(ChapterDashboardRelayPageQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(ChapterDashboardRelayPageQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(ChapterDashboardRelayPageQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(ChapterDashboardRelayPageQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function ChapterDashboardRelayPage$default(props) {
  let isLoggedIn = AuthSession.useIsLoggedIn();
  let data = use(undefined, undefined, undefined, undefined);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(PageTitle.make, {
        title: "Chapter Activity"
      }),
      isLoggedIn ? JsxRuntime.jsx(PageViews.RecordPageView.make, {
          page: PageViews.Page.makeChapterDashboardPage()
        }) : null,
      JsxRuntime.jsx(Container.make, {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs(DashboardCardComponents__Tw.StyledContentBox.make, {
              children: [
                JsxRuntime.jsx(DashboardCardComponents__Tw.Header.make, {
                  text: "Properties"
                }),
                JsxRuntime.jsx(FragmentErrorBoundary.make, {
                  fragmentDisplayName: "chapter dashboard property stats",
                  children: JsxRuntime.jsx(React.Suspense, {
                    children: JsxRuntime.jsx(ChapterDashboard__PropertyStats.make, {
                      query: data.fragmentRefs
                    }),
                    fallback: JsxRuntime.jsx(ChapterDashboard__PropertyStats.LoadingState.make, {})
                  })
                })
              ]
            }),
            JsxRuntime.jsxs(DashboardCardComponents__Tw.StyledContentBox.make, {
              children: [
                JsxRuntime.jsx(DashboardCardComponents__Tw.Header.make, {
                  text: "Client needs"
                }),
                JsxRuntime.jsx(FragmentErrorBoundary.make, {
                  fragmentDisplayName: "chapter dashboard buyer need stats",
                  children: JsxRuntime.jsx(React.Suspense, {
                    children: JsxRuntime.jsx(ChapterDashboard__BuyerNeedStats.make, {
                      query: data.fragmentRefs
                    }),
                    fallback: JsxRuntime.jsx(ChapterDashboard__BuyerNeedStats.LoadingState.make, {})
                  })
                })
              ]
            }),
            JsxRuntime.jsxs(DashboardCardComponents__Tw.StyledContentBox.make, {
              children: [
                JsxRuntime.jsx(DashboardCardComponents__Tw.Header.make, {
                  text: "Showings this week"
                }),
                JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
                  FallbackComponent: param => JsxRuntime.jsx(ChapterDashboard__UpcomingShowings.EmptyState.make, {}),
                  children: JsxRuntime.jsx(React.Suspense, {
                    children: JsxRuntime.jsx(ChapterDashboard__UpcomingShowings.make, {
                      query: data.fragmentRefs
                    }),
                    fallback: JsxRuntime.jsx(ChapterDashboard__UpcomingShowings.LoadingState.make, {})
                  })
                })
              ]
            }),
            JsxRuntime.jsxs(DashboardCardComponents__Tw.StyledContentBox.make, {
              children: [
                JsxRuntime.jsx(DashboardCardComponents__Tw.Header.make, {
                  text: "Broadcast Messages"
                }),
                JsxRuntime.jsx(FragmentErrorBoundary.make, {
                  fragmentDisplayName: "chapter dashboard broadcast messages",
                  children: JsxRuntime.jsx(React.Suspense, {
                    children: JsxRuntime.jsx(ChapterDashboard__BroadcastMessages.make, {
                      query: data.fragmentRefs
                    }),
                    fallback: JsxRuntime.jsx(ChapterDashboard__BroadcastMessages.LoadingState.make, {})
                  })
                })
              ]
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs(DashboardCardComponents__Tw.StyledContentBox.make, {
                children: [
                  JsxRuntime.jsx(DashboardCardComponents__Tw.Header.make, {
                    text: "TAN members"
                  }),
                  JsxRuntime.jsx(FragmentErrorBoundary.make, {
                    fragmentDisplayName: "chapter dashboard chapter members",
                    children: JsxRuntime.jsx(React.Suspense, {
                      children: JsxRuntime.jsx(ChapterDashboard__ChapterMembers.make, {
                        query: data.fragmentRefs
                      }),
                      fallback: JsxRuntime.jsx(ChapterDashboard__ChapterMembers.LoadingState.make, {})
                    })
                  })
                ]
              }),
              className: "lg:col-span-2"
            })
          ],
          className: "grid grid-cols-1 lg:grid-cols-2 gap-6"
        })
      })
    ]
  });
}

let DashboardCardComponents;

let BuyerNeedStats;

let PropertyStats;

let ChapterMembers;

let BroadcastMessages;

let UpcomingShowings;

let $$default = ChapterDashboardRelayPage$default;

exports.DashboardCardComponents = DashboardCardComponents;
exports.BuyerNeedStats = BuyerNeedStats;
exports.PropertyStats = PropertyStats;
exports.ChapterMembers = ChapterMembers;
exports.BroadcastMessages = BroadcastMessages;
exports.UpcomingShowings = UpcomingShowings;
exports.Query = Query;
exports.default = $$default;
exports.__esModule = true;
/* use Not a pure module */
